import React from 'react';
import { Controller, FieldError } from 'react-hook-form';
import { Control } from 'react-hook-form';
import { FieldValues } from 'react-hook-form';
import { FieldName } from '../core/field-name';
import FormFieldContainer from '../form-field-container.tsx/form-field-container';
import EssenceDatePicker from './date-picker';

interface DatePickerFormFieldProps<TValue, TForm extends FieldValues, TName extends FieldName<TForm, TValue>> {
	label?: string;
	control?: Control<TForm>;
	name: TName;
	error?: FieldError;
	className?: string;
}

export const EssenceDatePickerFormField = <TValue, TForm extends FieldValues, TName extends FieldName<TForm, TValue>>({
	label,
	control,
	name,
	error,
	className,
}: DatePickerFormFieldProps<TValue, TForm, TName>) => {
	return (
		<FormFieldContainer label={label} error={error} className={className}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange: fieldOnChange, ...field } }) => (
					<EssenceDatePicker date={field.value} onAccept={fieldOnChange} />
				)}
			/>
		</FormFieldContainer>
	);
};
